import { Document, Image, Page } from "@react-pdf/renderer";

const ReportDocument = ({ imageBlobs }) => {
  return (
    <Document>
      {imageBlobs.map((item, i) => (
        <Page key={i}>{item && <Image source={item} />}</Page>
      ))}
    </Document>
  );
};

export default ReportDocument;
